// src/components/pages/EventManager/atoms/InputField.js

import React from "react";
import { Box, Typography } from "@mui/material";
import PropTypes from "prop-types";

const InputField = ({
  label,
  type,
  value,
  onChange,
  required,
  inputMode,
  pattern,
  allowAllCharacters = true,
}) => {
  const handleKeyDown = (event) => {
    if (allowAllCharacters) return; // Skip restriction if all characters are allowed

    // Allow: Backspace, Tab, Enter, Arrow keys, Delete, etc.
    const allowedKeys = [
      "Backspace",
      "Tab",
      "Enter",
      "ArrowLeft",
      "ArrowRight",
      "Delete",
    ];
    // Prevent non-numeric input
    if (!allowedKeys.includes(event.key) && !/^\d$/.test(event.key)) {
      event.preventDefault();
    }
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Typography
        variant="body2"
        sx={{ mb: 1, color: "white", fontFamily: "basic-sans", fontWeight: 700 }}
      >
        {label}
      </Typography>
      <input
        style={{
          width: "100%",
          padding: "10px",
          marginTop: "8px",
          fontFamily: "basic-sans",
          fontWeight: 300,
          backgroundColor: "white",
          borderRadius: "5px",
          border: "1px solid #ccc",
        }}
        type={type}
        value={value}
        onChange={onChange}
        required={required}
        inputMode={inputMode}
        pattern={pattern}
        onKeyDown={handleKeyDown}
      />
    </Box>
  );
};

InputField.propTypes = {
  label: PropTypes.string.isRequired,
  type: PropTypes.oneOf(["text", "number", "date", "textarea"]).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  inputMode: PropTypes.string,
  pattern: PropTypes.string,
  allowAllCharacters: PropTypes.bool,
};

export default InputField;
